let countToken = "{count}";

/**
 * Returns a unique ID factory
 * @param template must contain `{count}` somewhere (to be replaced, to allow uniqueness)
 * @returns {function(): *}
 * @constructor
 */
export default function CreateIdFactory(template) {
  if (!template.includes(countToken)) {
    throw "ID template must contain '{count}' token";
  }
  let count = 0;
  return () => template.replace(countToken, count++);
}
